import axios from "axios";

import { BASE_URL } from "../../../constant";
import {
    handleFormatResponse,
    handleFormatResponseForError,
} from "../../../utility";

export const useStaticData = () => {
    const getStaticData = async (url: string) => {
        try {
            let response = await axios.get(`${BASE_URL}static/${url && url}`);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const getUnsecureStaticData = async (url: string) => {
        try {
            let response = await axios.get(`${BASE_URL}unsecure/static/${url && url}`);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    return {
        getStaticData,
        getUnsecureStaticData
    };

};